import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from "@mui/material";
import { NavBarAccountPagesLinks } from "./NavBarLinkComponents/NavBarAccountPagesLinks/NavBarAccountPagesLinks";
import { OrderNowButton } from "./OrderNowButton";
export const DesktopAccountLinks = () => {
    return (_jsxs(Stack, Object.assign({ spacing: 3, direction: "row", flexWrap: "wrap", alignItems: "baseline" }, { children: [_jsx(OrderNowButton, {}), _jsx(NavBarAccountPagesLinks, {})] })));
};
